export const typePaymentInvoice = [
    { id: 1, name: 'Unchecked' },
    { id: 2, name: 'Checked' },
]


// WEBPACK FOOTER //
// ./src/constant/TypePaymentInvoice.js